/**
TS1 (type 1) uses 3.4 V LiPo-style threshold; EMS IceSpy family (2,3,6,7) uses 1.4 V (matches sensor table).
Legacy types 4–5 do not expose this battery metric in the UI.
 */
export function getBatteryLowThresholdVolts(type: string | number | undefined): number | null {
  const t = String(type ?? '');
  switch (t) {
    case '1':
      return 3.4;
    case '2':
    case '3':
    case '6':
    case '7':
      return 1.4;
    default:
      return null;
  }
}

export const isLowBattery = (type: string, voltage: number): boolean => {
  const th = getBatteryLowThresholdVolts(type);
  if (th == null) return false;
  return voltage < th;
};

export const getBatteryStatus = (type: string, voltage: number): { color: string; text: string } => {
  const isLow = isLowBattery(type, voltage);
  return {
    color: isLow ? 'text-red-500' : 'text-green-500',
    text: `${voltage.toFixed(2)}V`
  };
};